import styled from 'styled-components';
import fn from '../../helpers/fn';

export default fn(__filename, styled.div`
  background-attachment: initial;
  background-image: linear-gradient(45deg, #e68600 0%, #333 100%);
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
`);



// WEBPACK FOOTER //
// ./src/components/blocks/Cover.js